interface HomeSchema {
    pageTitle: string;
    pageDescription: string;
    pageKeywords: string;
    canonicalUrl: string;
    homepageSchema: {
        "@context": string;
        "@type": string;
        name: string;
        description: string;
        url: string;
        telephone: string;
        address: {
            "@type": string;
            addressLocality: string;
            addressRegion: string;
            addressCountry: string;
        };
        serviceType: string[];
        areaServed: string;
    };
    homepageSchemaJson: string;
}


const pageTitle = "Home Care Services Dallas-Fort Worth | MASA HILLS Health Services";
const pageDescription = "Professional home care services for seniors and elderly in Dallas-Fort Worth. Compassionate in-home care, personal care services, and companion care. Licensed caregivers available 24/7.";
const pageKeywords = "home care services, elderly care, senior care agency, in-home care services, home health care, Dallas Fort Worth, personal care services, companion care services";
const canonicalUrl = "https://masahillshealthservices.com/";
const homepageSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MASA HILLS Health Services",
    "description": "Professional home care services for seniors and elderly in Dallas-Fort Worth area",
    "url": "https://masahillshealthservices.com",
    "telephone": "+14695730176",
    "address": {
        "@type": "3410 Texas Dr, Sachse, TX 75048",
        "streetAddress": "3410 Texas Dr",
        "addressLocality": "Sachse",
        "addressRegion": "TX",
        "postalCode": "75048",
        "addressCountry": "US"
    },
    "serviceType": [
        "Home Care Services",
        "Elderly Care",
        "Senior Care",
        "Personal Care Services",
        "Companion Care Services"
    ],
    "areaServed": "Dallas-Fort Worth, Texas"
};

const homepageSchemaJson = JSON.stringify(homepageSchema, null, 2);

const homeSchema: HomeSchema = {
    pageTitle,
    pageDescription,
    pageKeywords,
    canonicalUrl,
    homepageSchema,
    homepageSchemaJson
};
export default homeSchema;